var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 1.6275C11.2503 1.73955 11.2256 1.85025 11.1776 1.95149C11.1296 2.05272 11.0595 2.14191 10.9725 2.2125L6.47246 5.835C6.33826 5.94531 6.16993 6.00562 5.99621 6.00562C5.82249 6.00562 5.65416 5.94531 5.51996 5.835L1.01996 2.085C0.8668 1.9577 0.770482 1.77476 0.752197 1.57644C0.733912 1.37812 0.795159 1.18066 0.922463 1.0275C1.04977 0.874337 1.2327 0.778019 1.43102 0.759734C1.62934 0.741449 1.8268 0.802695 1.97996 0.929999L5.99996 4.2825L10.02 1.0425C10.13 0.950788 10.2641 0.892529 10.4063 0.87462C10.5484 0.85671 10.6927 0.879898 10.8221 0.94144C10.9515 1.00298 11.0606 1.1003 11.1364 1.22188C11.2122 1.34347 11.2516 1.48422 11.25 1.6275Z",
    fill: "#38D68B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.46b1acccbd7996af6fabf01154c8cc34.svg";
export { ForwardRef as ReactComponent };